import React from 'react';
import RptBgtAlloc from './Rpt_Budget_Alloc';
import '../../../CommonCSS/SocietyCSS.css'

const RptBgtAllocApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Budget Analysis Report</h5>
          </div>
        </div>
        <RptBgtAlloc />
      </div>
    </div >
  );
};

export default RptBgtAllocApp;
